import { createElementBlock as l, openBlock as o, createElementVNode as t } from "vue";
const n = {
  width: "31",
  height: "31",
  viewBox: "0 0 31 31",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-social_x"
};
function i(r, e) {
  return o(), l("svg", n, e[0] || (e[0] = [
    t("rect", {
      y: "3.05176e-05",
      width: "31",
      height: "31",
      rx: "15.5",
      fill: "#41648C"
    }, null, -1),
    t("path", {
      d: "M16.6416 14.561L21.1089 9.36818H20.0503L16.1714 13.877L13.0733 9.36818H9.5L14.1849 16.1864L9.5 21.6319H10.5587L14.6549 16.8704L17.9267 21.6319H21.5L16.6414 14.561H16.6416ZM15.1916 16.2465L14.717 15.5675L10.9401 10.1651H12.5661L15.6141 14.525L16.0888 15.204L20.0508 20.8712H18.4248L15.1916 16.2467V16.2465Z",
      fill: "white"
    }, null, -1)
  ]));
}
const c = { render: i };
export {
  c as default,
  i as render
};
